module.exports = "<app-header></app-header>\n<app-alert></app-alert>\n<router-outlet></router-outlet>\n"